var _excluded = ["border", "cssModule", "className", "fixedWidth", "flip", "inverse", "name", "pulse", "rotate", "size", "spin", "stack", "tag", "isSolid", "ariaLabel"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable no-unused-expressions */
import React from 'react';
export var srOnlyStyle = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: '0px',
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0px, 0px, 0px, 0px)',
  border: '0px'
};

/**
 * A React component for the fontawesome icon library.
 *
 *
 * @param {String} [ariaLabel] An extra accessibility label to put on the icon
 * @param {Boolean} [border=false] Whether or not to show a border radius
 * @param {String} [className] An extra set of CSS classes to add to the component
 * @param {Object} [cssModule] Option to pass FontAwesome CSS as a module
 * @param {Boolean} [fixedWidth=false] Make buttons fixed width
 * @param {String} [flip=false] Flip the icon's orientation.
 * @param {Boolean} [inverse=false]Inverse the icon's color
 * @param {String} name Name of the icon to use
 * @param {Boolean} [pulse=false] Rotate icon with 8 steps (rather than smoothly)
 * @param {Number} [rotate] The degress to rotate the icon by
 * @param {String} [size] The icon scaling size
 * @param {Boolean} [spin=false] Spin the icon
 * @param {String} [stack] Stack an icon on top of another
 * @param {String} [tag=span] The HTML tag to use as a string (eg 'i' or 'em')
 * @param {Boolean} [isSolid] FontAwesome 5 to use solid icons if true
 * @module FontAwesome
 * @type {ReactClass}
 */
export default class FontAwesomeAPM extends React.Component {
  render() {
    var _this$props = this.props,
        border = _this$props.border,
        cssModule = _this$props.cssModule,
        className = _this$props.className,
        fixedWidth = _this$props.fixedWidth,
        flip = _this$props.flip,
        inverse = _this$props.inverse,
        name = _this$props.name,
        pulse = _this$props.pulse,
        rotate = _this$props.rotate,
        size = _this$props.size,
        spin = _this$props.spin,
        stack = _this$props.stack,
        _this$props$tag = _this$props.tag,
        Tag = _this$props$tag === void 0 ? 'i' : _this$props$tag,
        isSolid = _this$props.isSolid,
        ariaLabel = _this$props.ariaLabel,
        props = _objectWithoutProperties(_this$props, _excluded);

    var classNames = [];

    if (cssModule) {
      classNames.push(cssModule.fa);
      classNames.push(cssModule[`fa-${name}`]);
      size && classNames.push(cssModule[`fa-${size}`]);
      spin && classNames.push(cssModule['fa-spin']);
      pulse && classNames.push(cssModule['fa-pulse']);
      border && classNames.push(cssModule['fa-border']);
      fixedWidth && classNames.push(cssModule['fa-fw']);
      flip && classNames.push(cssModule[`fa-flip-${flip}`]);
      rotate && classNames.push(cssModule[`fa-rotate-${rotate}`]);
      stack && classNames.push(cssModule[`fa-stack-${stack}`]);
      inverse && classNames.push(cssModule['fa-inverse']);
    } else {
      classNames.push(name);
      size && classNames.push(size);
      spin && classNames.push('spin');
      pulse && classNames.push('pulse');
      border && classNames.push('border');
      fixedWidth && classNames.push('fw');
      flip && classNames.push(`flip-${flip}`);
      rotate && classNames.push(`rotate-${rotate}`);
      stack && classNames.push(`stack-${stack}`);
      inverse && classNames.push('inverse');
      var fa = classNames.map(iconName => `fa-${iconName}`);
      isSolid ? fa.unshift('fas') : fa.unshift('fa');
      classNames = fa;
    } // Add any custom class names at the end.


    className && classNames.push(className);
    return /*#__PURE__*/React.createElement(Tag, _extends({}, props, {
      "aria-hidden": true,
      className: classNames.join(' ')
    }), ariaLabel && /*#__PURE__*/React.createElement("span", {
      style: srOnlyStyle
    }, ariaLabel));
  }

}
FontAwesomeAPM.displayName = "FontAwesomeAPM";